import { QueryClient } from "@tanstack/react-query"

export const defaultApiRoute = "advertisers"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})
